import { Injectable, isDevMode, ɵɵdefineInjectable, InjectionToken, Component, Injector, Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpResponse, HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { tap, finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import * as marked from 'marked';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@ngx-translate/core';
class CorsInterceptor {
    intercept(req, next) {
        // Clone the request and replace the original headers with
        // cloned headers, updated with the authorization.
        const authReq = req.clone({
            headers: req.headers.set('Access-Control-Allow-Origin', '*'),
        });
        return next.handle(authReq);
    }
}
CorsInterceptor.ɵfac = function CorsInterceptor_Factory(t) { return new (t || CorsInterceptor)(); };
CorsInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CorsInterceptor, factory: CorsInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CorsInterceptor, [{
        type: Injectable
    }], null, null); })();

class LoggerColor {
    constructor(titleColor, messageColor) {
        this.titleColor = titleColor;
        this.messageColor = messageColor;
    }
}
/**
 * Gives logging functionality to console
 */
class Logger {
    constructor() {
        this.showLogo();
    }
    /**
     * Shows SPE Logo
     */
    showLogo() {
        this.log(this, {
            message: `
    ____ ___  _   _  ____ ___ _     ___ ___
   / ___/ _ \\| \\ | |/ ___|_ _| |   |_ _/ _ \\
  | |  | | | |  \\| | |    | || |    | | | | |
  | |__| |_| | |\\  | |___ | || |___ | | |_| |
   \\____\\___/|_| \\_|\\____|___|_____|___\\___/

`, title: new Date()
        }, new LoggerColor('black', 'black'));
    }
    /**
     * Logs an error
     * @param context: Usually class name
     * @param title
     * @param message
     */
    logError(context, title, message = null) {
        if (isDevMode()) {
            /* if (!context.className) {
               throw new Error('ClassName not set!');
             }*/
            message ? console.error(`[ ${context.className || ''} ] ${title}`, message) : console.error(`[ ${context.className} ] ${title}`);
        }
    }
    /**
     * Logs to console with custom colors
     * @param context
     * @param text
     * @param colors
     */
    log(context, text, colors) {
        if (isDevMode()) {
            if (colors) {
                if (colors.titleColor && colors.messageColor) {
                    text.message ? console.log(`%c[ ${context.constructor.name} ] %c ${text.title}`, `color:${colors.titleColor}`, `color:${colors.messageColor}`, text.message) : console.log(`%c[ ${context.constructor.name} ] %c ${text.title}`, `color:${colors.titleColor}`, `color:${colors.messageColor}`);
                }
                else {
                    this.logDefaultColors(context, text.message, text.title);
                }
            }
            else {
                this.logDefaultColors(context, text.message, text.title);
            }
        }
    }
    /**
     * Logs to console
     * @param context
     * @param message
     * @param title
     */
    logDefaultColors(context, message, title) {
        message ? console.log(`%c[ ${context.constructor.name} ] %c ${title}`, 'color:green', 'color:blue', message) : console.log(`%c[ ${context.constructor.name} ] %c ${title}`, 'color:green', 'color:#0094ba');
    }
}
Logger.ɵfac = function Logger_Factory(t) { return new (t || Logger)(); };
Logger.ɵprov = ɵɵdefineInjectable({ factory: function Logger_Factory() { return new Logger(); }, token: Logger, providedIn: "root" });
Logger.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Logger, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class LoggingInterceptor {
    constructor(logger) {
        this.logger = logger;
        this.colors = new LoggerColor('#b36b00', '#ff9900');
    }
    intercept(req, next) {
        this.logger.log(this, { title: 'HTTP request', message: req.url }, this.colors);
        return next.handle(req)
            .pipe(tap(
        // Succeeds when there is a response; ignore other events
        (event) => {
            var _a;
            if (event instanceof HttpResponse) {
                this.logger.log(this, { title: 'Response', message: (_a = event.body) === null || _a === void 0 ? void 0 : _a.toString() }, this.colors);
            }
        }, 
        // Operation failed; error is an HttpErrorResponse
        error => {
            this.logger.logError(this, 'Error', error);
        }), 
        // Log when response observable either completes or errors
        finalize(() => {
        }));
    }
}
LoggingInterceptor.ɵfac = function LoggingInterceptor_Factory(t) { return new (t || LoggingInterceptor)(ɵngcc0.ɵɵinject(Logger)); };
LoggingInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoggingInterceptor, factory: LoggingInterceptor.ɵfac });
LoggingInterceptor.ctorParameters = () => [
    { type: Logger }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggingInterceptor, [{
        type: Injectable
    }], function () { return [{ type: Logger }]; }, null); })();

class ConcilioUtilsService {
    constructor() { }
    isNullOrUndefined(value) {
        return value === null || value === undefined;
    }
    lightOrDark(color) {
        // Variables for red, green, blue values
        let r, g, b, hsp;
        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
            // If HEX --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            r = color[1];
            g = color[2];
            b = color[3];
        }
        else {
            // If RGB --> Convert it to HEX: http://gist.github.com/983661
            color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
            // tslint:disable-next-line:no-bitwise
            r = color >> 16;
            // tslint:disable-next-line:no-bitwise
            g = color >> 8 & 255;
            // tslint:disable-next-line:no-bitwise
            b = color & 255;
        }
        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b));
        // Using the HSP value, determine whether the color is light or dark
        if (hsp > 127.5) {
            return 0;
        }
        else {
            return 1;
        }
    }
    formatDate(date) {
        return moment(date).format('DD-MM-YYYY HH:mm');
    }
}
ConcilioUtilsService.ɵfac = function ConcilioUtilsService_Factory(t) { return new (t || ConcilioUtilsService)(); };
ConcilioUtilsService.ɵprov = ɵɵdefineInjectable({ factory: function ConcilioUtilsService_Factory() { return new ConcilioUtilsService(); }, token: ConcilioUtilsService, providedIn: "root" });
ConcilioUtilsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConcilioUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const COMPONENT_LIVECYCLE_DEBUG_MODE = new InjectionToken('debugComponentLivecycle');

class ConcilioComponent {
    constructor(injector) {
        this.injector = injector;
        this.guid = Guid.newGuid();
        this.subscription = new Subscription();
        this.translateService = injector.get(TranslateService);
        this.logger = injector.get(Logger);
        this.utils = injector.get(ConcilioUtilsService);
        this.snackBar = injector.get(MatSnackBar);
        this.debugComponentLifeCycle = injector.get(COMPONENT_LIVECYCLE_DEBUG_MODE);
        this.routerService = injector.get(Router);
        this.route = injector.get(ActivatedRoute);
        this.dialog = injector.get(MatDialog);
    }
    toastSuccess(message, actionLabel, duration = 2000) {
        this.snackBar.open(message, actionLabel, {
            duration,
        });
    }
    toastError(message, actionLabel, duration = 5000) {
        this.snackBar.open(message, actionLabel, {
            duration,
            panelClass: ['error-snack'],
        });
    }
    addSubscription(sub) {
        if (sub) {
            this.subscription.add(sub);
        }
        return sub;
    }
    /**
     * Helper method for logging
     */
    trace(title, message = null) {
        this.logger.log(this, { title, message }, new LoggerColor(null, null));
    }
    /**
     * Helper method for logging with assigned colors(LoggerColor)
     */
    log(title, message = null) {
        this.logger.log(this, { title, message }, this.colors);
    }
    /**
     * Helper method for logging with custom colors
     */
    logColors(title, message = null, colors) {
        this.logger.log(this, { title, message }, this.colors);
    }
    /**
     * Helper method for logging errors
     */
    error(title, message = null) {
        this.logger.logError(this, title, message);
    }
    ngOnInit() {
        if (this.debugComponentLifeCycle) {
            this.trace('[ngOnInit]');
        }
    }
    ngOnDestroy() {
        if (this.debugComponentLifeCycle) {
            this.trace('[ngOnDestroy]');
        }
        this.subscription.unsubscribe();
    }
    ngAfterViewInit() {
        if (this.debugComponentLifeCycle) {
            this.trace('[ngAfterViewInit]');
        }
    }
}
ConcilioComponent.ɵfac = function ConcilioComponent_Factory(t) { return new (t || ConcilioComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
ConcilioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ConcilioComponent, selectors: [["concilio-core-main"]], decls: 0, vars: 0, template: function ConcilioComponent_Template(rf, ctx) { }, encapsulation: 2 });
ConcilioComponent.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConcilioComponent, [{
        type: Component,
        args: [{
                selector: `concilio-core-main`,
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
class Guid {
    /**
     * Generates a guid
     */
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            // tslint:disable-next-line:no-bitwise one-variable-per-declaration
            const r = (Math.random() * 16) | 0, 
            // tslint:disable-next-line:no-bitwise
            v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer, 16)); };
SafePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }]; }, null); })();

class FilterByPipe {
    transform(values, array, prop) {
        let result = values;
        if (Array.isArray(array)) {
            result = values.map((v) => array.find((a) => a[prop] === v[prop])).filter((v) => !!v);
        }
        else {
            prop = array;
            result = values.filter((v) => v[prop]);
        }
        if (result.length > 0)
            return result;
        return values;
    }
}
FilterByPipe.ɵfac = function FilterByPipe_Factory(t) { return new (t || FilterByPipe)(); };
FilterByPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "filterBy", type: FilterByPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterByPipe, [{
        type: Pipe,
        args: [{
                name: 'filterBy'
            }]
    }], null, null); })();

class FilterControlsByPipe {
    transform(values, array, prop) {
        let result = values;
        if (Array.isArray(array)) {
            result = values.map((v) => new FormGroup(array.find((a) => a[prop] === v.value[prop]))).filter((v) => !!v);
        }
        else {
            prop = array;
            result = values.filter((v) => v.value[prop]);
        }
        if (result.length > 0)
            return result;
        return values;
    }
}
FilterControlsByPipe.ɵfac = function FilterControlsByPipe_Factory(t) { return new (t || FilterControlsByPipe)(); };
FilterControlsByPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "filterControlsBy", type: FilterControlsByPipe, pure: false });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterControlsByPipe, [{
        type: Pipe,
        args: [{
                name: 'filterControlsBy',
                pure: false
            }]
    }], null, null); })();

class FilterPipe {
    transform(values, prop, value) {
        let result = Object.assign({}, values);
        const props = prop.split('.');
        if (value) {
            result = values === null || values === void 0 ? void 0 : values.filter((v) => {
                const p = props.reduce((acc, val) => {
                    acc = acc[val];
                    return acc;
                }, v);
                return p === value;
            });
        }
        else {
            result = values === null || values === void 0 ? void 0 : values.filter((v) => {
                const p = props.reduce((acc, val) => {
                    acc = acc[val];
                    return acc;
                }, v);
                return p;
            });
        }
        if ((result === null || result === void 0 ? void 0 : result.length) > 0)
            return result;
        return values;
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: false });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter',
                pure: false
            }]
    }], null, null); })();

class UcfirstPipe {
    transform(value, ...args) {
        if (value.includes('.')) {
            return value
                .split('.')
                .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
                .join(' ');
        }
        return value
            .split(' ')
            .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
            .join(' ');
    }
}
UcfirstPipe.ɵfac = function UcfirstPipe_Factory(t) { return new (t || UcfirstPipe)(); };
UcfirstPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ucfirst", type: UcfirstPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UcfirstPipe, [{
        type: Pipe,
        args: [{
                name: 'ucfirst'
            }]
    }], null, null); })();

class MarkdownPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, ...args) {
        if (!value) {
            return null;
        }
        // const trustValue = this.sanitizer.bypassSecurityTrustUrl(value);
        return marked(value);
    }
}
MarkdownPipe.ɵfac = function MarkdownPipe_Factory(t) { return new (t || MarkdownPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer, 16)); };
MarkdownPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "markdown", type: MarkdownPipe, pure: true });
MarkdownPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarkdownPipe, [{
        type: Pipe,
        args: [{
                name: 'markdown'
            }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }]; }, null); })();

const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: CorsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
];
const COMPONENTS = [];
const translateModule = TranslateModule.forChild();
class ConcilioCoreModule {
}
ConcilioCoreModule.ɵfac = function ConcilioCoreModule_Factory(t) { return new (t || ConcilioCoreModule)(); };
ConcilioCoreModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ConcilioCoreModule });
ConcilioCoreModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: COMPONENT_LIVECYCLE_DEBUG_MODE, useValue: true },
        httpInterceptorProviders,
    ], imports: [[
            CommonModule,
            translateModule,
            HttpClientModule,
            ReactiveFormsModule,
            FormsModule,
            RouterModule,
        ], HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConcilioCoreModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    translateModule,
                    HttpClientModule,
                    ReactiveFormsModule,
                    FormsModule,
                    RouterModule,
                ],
                declarations: [
                    ConcilioComponent,
                    SafePipe,
                    FilterByPipe,
                    FilterControlsByPipe,
                    FilterPipe,
                    UcfirstPipe,
                    MarkdownPipe,
                ],
                exports: [
                    HttpClientModule,
                    SafePipe,
                    FilterByPipe,
                    FilterControlsByPipe,
                    FilterPipe,
                    UcfirstPipe,
                    MarkdownPipe
                ],
                providers: [
                    { provide: COMPONENT_LIVECYCLE_DEBUG_MODE, useValue: true },
                    httpInterceptorProviders,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ConcilioCoreModule, { declarations: function () { return [ConcilioComponent, SafePipe, FilterByPipe, FilterControlsByPipe, FilterPipe, UcfirstPipe, MarkdownPipe]; }, imports: function () { return [CommonModule, ɵngcc2.TranslateModule, HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule]; }, exports: function () { return [HttpClientModule, SafePipe, FilterByPipe, FilterControlsByPipe, FilterPipe, UcfirstPipe, MarkdownPipe]; } }); })();

function createError(params) {
    return {
        status: 0,
        statusText: '',
        url: '',
        ok: false,
        name: '',
        message: ''
    };
}

class ConcilioServiceApi {
    constructor(injector, endPoint, migrationEndPoint) {
        this.migrationUrl = '';
        this.baseUrl = '';
        this.endPoint = endPoint;
        this.migrationEndPoint = migrationEndPoint;
        this.httpClient = injector.get(HttpClient);
        this._environment = injector.get('environment', null);
        if (!this._environment) {
            this.logger.logError('Environment Injection token missing inside app.module', 'You must specify an injection token from "environment" value');
        }
        else {
            this.baseUrl = this._environment.baseUrl;
            this.url = this.baseUrl + this.endPoint;
            if (this.migrationEndPoint)
                this.migrationUrl = this._environment.migrationUrl + this.migrationEndPoint;
        }
    }
}

/*
 * Public API Surface of concilio-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { COMPONENT_LIVECYCLE_DEBUG_MODE, ConcilioComponent, ConcilioCoreModule, ConcilioServiceApi, ConcilioUtilsService, FilterByPipe, FilterControlsByPipe, FilterPipe, Logger, LoggerColor, MarkdownPipe, SafePipe, UcfirstPipe, createError, httpInterceptorProviders, translateModule, CorsInterceptor as ɵa, LoggingInterceptor as ɵb, SafePipe as ɵc, FilterByPipe as ɵd, FilterControlsByPipe as ɵe, FilterPipe as ɵf, UcfirstPipe as ɵg };

